import { render } from "./Investigation.Scope.vue?vue&type=template&id=493ed2c2"
import script from "./Investigation.Scope.vue?vue&type=script&lang=js"
export * from "./Investigation.Scope.vue?vue&type=script&lang=js"

import "./Investigation.Scope.vue?vue&type=style&index=0&id=493ed2c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__